export default {
  _name: 'dark',
  _appearance: 'dark',

  background: '#031A3A',
  border: '#063374',
  overlay: '#02142E',
  content: '#DEE2E7',
  contentSecondary: '#ACB5C2',

  surface: '#041F46',
  surfaceContent: '#DFE3EA',
  surfaceContentSecondary: '#ACB5C2',
  surfaceIcon: '#DFE3EA',
  surfaceUnder: '#042451',
  surfaceOpened: '#7c99d6',
  surfaceSelected: '#405071',
  surfaceHighlight: '#405071',
  surfacePressed: '#3f4e6d',
  surfaceInteractive: '#05295D',
  surfaceSummary: '#51709E',

  feedbackSurface: '#4c5d82',
  feedbackSurfaceContent: '#212B36',
  feedbackSurfaceContentSecondary: '#637381',

  warning: '#FFA410',
  warningSurface: '#2A1F0E',
  warningSurfaceContent: '#FFA410',

  info: '#18D4FB',
  infoSurface: '#073657',
  infoSurfaceContent: '#18D4FB',

  help: '#DEE2E7',
  helpIcon: '#88A8E4',
  helpSurface: '#052E68',
  helpContent: '#031A3A',
  helpSurfaceContent: '#212B36',

  negative: '#FF6D6D',
  negativeContent: '#4C2121',
  negativeSurface: '#3E1F26',
  negativeSurfaceContent: '#FF6D6D',

  positive: '#2BC58E',
  positiveContent: '#0D3B2B',
  positiveSurface: '#0A332B',
  positiveSurfaceContent: '#2cc68f',

  badge: '#1F4782',
  badgeContent: '#DEE2E7',
  badgePressed: '#4c5d82',

  tagIdentifier: '#564090',
  tagIdentifierContent: '#b6a1ff',

  tagNew: '#35585e',
  tagNewContent: '#2cc68f',

  tagIndicator: '#415279',
  tagIndicatorContent: '#00d3ff',

  tagActivity: '#00d2ff',
  tagActivityContent: '#FFFFFF',

  hint: '#6683c3',
  link: '#7CA8FF',
  focus: '#7CE0D6',
  selected: '#7CE0D6',
  selectedContent: '#171551',
  selectedDisabled: '#212B36',

  disabled: '#02142E',
  disabledContent: '#818A97',
  disabledBorder: '#1F4782',
  disabledIcon: '#6683c3',

  control: '#031A3A',
  controlBorder: '#2c3a58',
  controlBorderPressed: '#65779a',
  controlDisabled: '#3f4e6f',
  controlSurface: '#F9FAFC',
  controlUnder: '#F1F3F7',

  celeste: '#7C6CB3',
  celesteContent: '#33276D',
  celesteBorder: '#7C6CB3',
  celesteSurface: '#120F19',

  challenge: '#99620A',
  challengeBorder: '#99620A',
  challengeSurface: '#191002',

  accent: '#7FDBBD',
  accentStart: '#64B7B4',
  accentEnd: '#7FDBBD',
  accentContent: '#13334b',

  floating: '#1c2539',
  floatingContent: '#FFFFFF',

  green: '#2BC58E',
  yellow: '#FFA410',
  red: '#FF6D6D',
  blue: '#00d3ff',
  brown: '#99620A',
  purple: '#B19AFF',
}
